// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voucher-form[data-v-911e0b9c]{max-width:600px}.form-control[data-v-911e0b9c]{margin:0;border-radius:0;height:46px;padding:0 15px;border:1px solid #ccc;color:#47403a;font-size:17px;width:100%;text-align:left}", ""]);
// Exports
module.exports = exports;
